import React from "react";

const EmptyState = ({ icon: Icon, title, description, action, className = "" }) => {
  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 ${className}`}>
      {Icon && (
        <div className="w-16 h-16 bg-neutral-light dark:bg-glass-dark rounded-full flex items-center justify-center mb-4">
          <Icon className="w-8 h-8 text-neutral-dark" />
        </div>
      )}
      <h3 className="text-lg font-medium text-text dark:text-neutral-light mb-2">
        {title}
      </h3>
      {description && (
        <p className="text-neutral-dark dark:text-neutral-light text-center max-w-md mb-6">
          {description}
        </p>
      )}
      {action && <div>{action}</div>}
    </div>
  );
};

export default EmptyState;
